module.exports = __webpack_public_path__ + "static/media/frames-20.a12b4d43.jpg";